import { createReducer } from '@reduxjs/toolkit'

import { defaultTab, getDefaultList } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    list: getDefaultList({
        sorter: {
            field: 'created_at',
            order: 'descend',
        },
    }),
}

export default createReducer(initialState, () => {})
